<template>
  <div id="TaskHistory">
    <h2>教育局任务报告</h2>
    <a-table bordered :dataSource="taskChild" :columns="columns" :pagination="pagination" :rowKey="row => row.ID">
      <div slot="TASK_START_DATE" slot-scope="text, record">
        <span>{{record.TASK_START_DATE}}</span>
        <span>—</span>
        <span>{{record.TASK_END_DATE}}</span>
      </div>
      <div slot="PROGRESS" slot-scope="text, record">
        <a-progress :percent="parseFloat(parseFloat(record.PROGRESS).toFixed(2))" :strokeWidth="6" />
      </div>
      <div slot="EVALUATION_PROGRESS" slot-scope="text, record">
        <a-progress :percent="parseFloat(parseFloat(record.EVALUATION_PROGRESS).toFixed(2))" :strokeWidth="6" />
      </div>
      <div slot="PARENT_PROGRESS" slot-scope="text, record">
        <a-progress v-if="orderStatus(record.TASK_START_DATE)" :percent="parseFloat(parseFloat(record.PARENT_PROGRESS).toFixed(2))" :strokeWidth="6" />
        <div v-else style="text-align: center;">—</div>
      </div>
      <div slot="operation" slot-scope="text, record">
        <span v-if="record.STATUS === 0 && (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/')))">待分发</span>
        <span v-if="record.STATUS !== 0 && (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/'))) && (parseInt(record.PROGRESS) !== 100)">进行中</span>
        <span v-if="(new Date(new Date() - 24 * 60 * 60 * 1000) > new Date(record.TASK_END_DATE.replace(/-/g, '/'))) || (parseInt(record.PROGRESS) === 100)">已结束</span>
      </div>
      <div slot="seereport" slot-scope="text, record">
        <div class="operation">
          <span style="color: #1890FF;cursor: pointer;" :class="(record.STATUS === 0 && (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/')))) ? 'no' : ''" @click="viewUndetected(record)">进入报告库</span>
          <span v-if="record.isCrisis && (roleID === 1 || roleID === 2)" style="color: #1890FF;cursor: pointer;margin-top: 4px" @click="crisisHandle(record)">任务危机管理</span>
          <!-- <span v-if="orderStatus(record.TASK_START_DATE)" style="color: #1890FF;cursor: pointer;margin-top: 4px" @click="exportConfirmHandle(record.DQ_ID, record.TASK_NAME)">导出回执进度</span> -->
        </div>
      </div>
    </a-table>
    <a-drawer :width="1200" :visible="visible" :body-style="{ paddingBottom: '80px', paddingTop: '32px' }" :destroyOnClose="true" :closable="false" @close="onClose">
      <span class="back" @click="onClose" style="margin-left: 40px;padding: 8px;box-sizing: border-box;">
        <a-icon type="left" />
        返回
      </span>
      <drawer-view></drawer-view>
    </a-drawer>
  </div>
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex'
  import URL from '@/store/url'
  import DrawerView from './DrawerView'
  import XLSX from 'xlsx'
  import GradeNew from '@/util/gradeNew'

  export default {
    name: 'TaskHistory',
    data () {
      return {
        columns: [
          {
            title: '任务名称',
            dataIndex: 'TASK_NAME',
            width: '18%',
            scopedSlots: { customRender: 'TASK_NAME' },
          },
          {
            title: '时间范围',
            dataIndex: 'TASK_START_DATE',
            width: '22%',
            scopedSlots: { customRender: 'TASK_START_DATE' }
          },
          {
            title: '测评完成度',
            dataIndex: 'PROGRESS',
            width: '13%',
            scopedSlots: { customRender: 'PROGRESS' }
          },
          {
            title: '班主任评估进度',
            dataIndex: 'EVALUATION_PROGRESS',
            width: '13%',
            scopedSlots: { customRender: 'EVALUATION_PROGRESS' }
          },
          // {
          //   title: '家长回执进度',
          //   dataIndex: 'PARENT_PROGRESS',
          //   width: '13%',
          //   scopedSlots: { customRender: 'PARENT_PROGRESS' }
          // },
          {
            title: '状态',
            key: 'operation',
            scopedSlots: { customRender: 'operation' }
          },
          {
            title: '操作',
            key: 'seereport',
            scopedSlots: { customRender: 'seereport' }
          }
        ],
        pagination: {
          pageSize: 7, // 默认每页显示数量
          showQuickJumper: true,
          // showSizeChanger: true
        },
        questionnairenTaskNew: [],
        taskChild: [],
        visible: false,
        roleID: null
      }
    },
    computed: {
      ...mapState([
        'questionnairenTask',
        'asyncFlag',
        'teacherAdmin',
        'teacherDQID',
        'teacherENDTIME',
        'parentConfirmArr', // 导出的家长回执名单
        'confirmProgress', // 获取回执进度
        'userInfo'
      ])
    },
    components: {
      DrawerView
    },
    methods: {
      ...mapActions([
        'asyncTeacherData',
        'getParentConfirm',
        'getConfirmProgress'
      ]),
      ...mapMutations([
        'setTaskReport'
      ]),
      async viewUndetected (record) { // 查看报告库
        record.type = 0 // 教育局
        record.qid = record.DQ_ID
        record.title = record.TASK_NAME
        record.start_time = record.TASK_START_DATE
        record.end_time = record.TASK_END_DATE
        if (!(record.STATUS === 0 && (new Date(new Date() - 24 * 60 * 60 * 1000) < new Date(record.TASK_END_DATE.replace(/-/g, '/'))))) {
          this.visible = true // 打开抽屉
          this.setTaskReport(record)
          this.asyncData(record)
        }
      },
      crisisHandle (record) { // 任务危机管理
				let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
				this.asyncData(record)
				window.open(`${URL.TO_CRISIS}crisisChoose?schoolId=${this.teacherAdmin.school_id}&teacherUid=${this.teacherAdmin.uid}&city=${this.teacherAdmin.city}&token=${this.teacherAdmin.tokenValue}&schoolName=${this.teacherAdmin.school_name}&minGrade=${userInfo.min_grade}&maxGrade=${userInfo.max_grade}&roleId=${userInfo.role_id}&jwt=${this.teacherAdmin.jwt}&dqid=${record.DQ_ID}&teacherDqid=${this.teacherDQID}&teacherEndtime=${this.teacherENDTIME}&cp=${userInfo.OPEN_TEACHER_CP}&sid=${record.sid === 993548 ? 993548 : 993541}&start_time=${record.TASK_START_DATE}&end_time=${record.TASK_END_DATE}&schoolType=${userInfo.SCHOOL_TYPE}`)
			},
      onClose () { // 关闭抽屉
        this.visible = false
      },
      async asyncData (record) { // 同步无效数据
				if (record.isCrisis && record.DQ_ID) {
					await this.asyncTeacherData({SID: record.sid, DQ_ID: record.DQ_ID})
					if (!this.asyncFlag) {
						this.$message.error('更新团体报告无效数据失败')
					}
				}
			},
      orderStatus (item) { // 判断任务开始时间是否在家长回执进度上线后
        const moment = require('moment')
        if (moment(item).isSameOrAfter('2022-12-26')) {
          return true
        } else {
          return false
        }
      },
      async exportConfirmHandle (item, info) { // 导出回执名单
        let list = []
        if (item) {
          await this.getParentConfirm({
            dqid: item
          })
        }
        if (this.parentConfirmArr.length) {
          for (let i of this.parentConfirmArr) {
            list.push({'姓名': i.REAL_NAME, '年级': i.GRADE_ID ? GradeNew(i.GRADE_ID).tableGrade : '暂无', '班级': `${i.CLASS_ID}班`, '是否收到回执': i.STATUS ? '是' : '否'})
          }
        } else {
          list.push({'姓名': '', '年级': '', '班级': '', '是否收到回执': ''})
        }
        let wb = {
          SheetNames: [],
          Sheets: { sheet1: 'ww' }
        }
        let ws = XLSX.utils.json_to_sheet(list)
        XLSX.utils.book_append_sheet(wb, ws, '回执进度')
        XLSX.writeFile(wb, `${info}的回执进度.xlsx`, { compression: true })
        console.log(this.parentConfirmArr, 1555)
      }
    },
    async mounted () {
      let dqidArr = []
      this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
      this.questionnairenTask.map((value) => {
        if (new Date() > new Date(value.TASK_START_DATE.replace(/-/g, '/'))) {
          this.questionnairenTaskNew.push(value)
        }
      })
      if (this.questionnairenTaskNew && this.questionnairenTaskNew.length) { // 有满足条件的父任务
        let crisis = [993541, 993544, 993548, 995000, 995002]
        this.questionnairenTaskNew.map(item => {
          if (item.CHILDREN && item.CHILDREN.length) { // 有子任务
            this.taskChild = this.taskChild.concat(item.CHILDREN)
          }
        })
        this.taskChild.map(child => {
          if (this.orderStatus(child.TASK_START_DATE) && child.DQ_ID) {
            dqidArr.push(child.DQ_ID)
          }
          child['PROGRESS_BAN'] = 10.00
          let topics = []
          child.list = []
          child.SURVEY_LIST.map(list => {
            topics.push(list.SID)
          })
          child.topics = topics.join(',')
          topics.map(val => {
            child.list.push(parseInt(val))
            // (已分发 & 包含危机量表) ==> 显示“任务危机管理”按钮
            if (child.STATUS !== 0) {
              if (crisis.includes(parseInt(val))) {
                child.isCrisis = true
                child.sid = parseInt(val)
              }
            }
          })
        })
        console.log(this.taskChild, 221)
      }
      // if (dqidArr.length) {
      //   await this.getConfirmProgress({list: dqidArr})
      // }
      // if (this.confirmProgress.length) {
      //   for (let i of this.confirmProgress) {
      //     for (let k of this.taskChild) {
      //       if (k.DQ_ID === i.DQ_ID) {
      //         k['PARENT_PROGRESS'] = i.process
      //       }
      //     }
      //   }
      // }
    }
  }
</script>

<style scoped>
  #TaskHistory h2 {
    font-size: 24px;
    color: #262626;
    font-weight: bold;
    margin-bottom: 24px;
  }
  #TaskHistory /deep/ .ant-table-wrapper {
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    margin-bottom: 80px;
  }
  #TaskHistory /deep/ table {
    border: 0px;
  }
  #TaskHistory /deep/ .ant-table-tbody > tr > td {
    font-size: 14px;
    color: #262626;
  }
  #TaskHistory /deep/ .ant-table-thead > tr > th {
    font-size: 12px;
    color: #8C8C8C;
  }
  #TaskHistory /deep/ .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    border-right: 0px;
    margin-left: 0px;
  }
  #TaskHistory /deep/ .ant-progress-outer {
    width: 80%;
  }
  #TaskHistory /deep/ .ant-progress-success-bg, #TaskHistory /deep/ .ant-progress-bg, #TaskHistory /deep/ .ant-progress-circle-path{
    background: #D9D9D9;
    stroke: #D9D9D9!important;
  }
  #TaskHistory /deep/ .ant-progress-status-success .ant-progress-text {
    color: #D9D9D9;
  }
  #TaskHistory /deep/ .ant-table-pagination.ant-pagination {
    margin-right: 24px;
  }
  #TaskHistory .no {
    color: #CCCCCC!important;
    cursor: not-allowed!important;
  }
  .back:hover {
    background: #F5F5F5;
    cursor: pointer;
  }
  #TaskHistory .operation {
    display: flex;
    flex-direction: column;
  }
</style>
